import { Button, Image } from "@chakra-ui/react";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CTable from "../../../components/Table/table";

const baseUrl = "https://api.asquera.com/";

const SubjectsTable = ({ searchTerm }) => {
  const subjects = useSelector((state) => state.subjects.subjects);
  const isLoading = useSelector((state) => state.subjects.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const handleCopyLink = async (subjectId) => {
    const link = `https://asquera.com/login?subject_id=${subjectId}`;
    try {
      await navigator.clipboard.writeText(link);
      toast.success("تم نسخ الرابط");
    } catch {
      toast.error("فشل نسخ الرابط");
    }
  };

  const filteredSubjects = subjects?.filter((subject) =>
    subject.name?.toLowerCase().includes((searchTerm || "").toLowerCase())
  );

  const Data = filteredSubjects?.map((data) => {
    return {
      ...data,
      id: data?.id,
      name: data?.name,
      logo: (
        <Image
          src={data?.logo ? baseUrl + data.logo : "/logo.png"}
          alt={data?.name}
          boxSize="50px"
          objectFit="cover"
          borderRadius="8px"
        />
      ),
      copy_link: (
        <Button
          size="sm"
          bg="main_1"
          color="white"
          borderRadius="8px"
          _hover={{ opacity: 0.9 }}
          onClick={() => handleCopyLink(data?.id)}
        >
          نسخ الرابط
        </Button>
      ),
    };
  });

  const columns = [
    {
      Header: "الشعار",
      accessor: "logo",
    },
    {
      Header: "الاسم",
      accessor: "name",
    },
    {
      Header: "نسخ الرابط",
      accessor: "copy_link",
    },
  ];

  return (
    <CTable
      selectedData={() => {}}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil((filteredSubjects?.length || 0) / size)}
    />
  );
};

export default SubjectsTable;
